<template>
  <div class="progress-bar-container">
    <div class="progress-bar" :style="{ width: safeProgress + '%' }"></div>
  </div>
</template>

<script>
export default {
  props: {
    progress: {
      type: Number,
      required: true
    }
  },
  computed: {
    safeProgress() {
      const clamped = Math.max(0, Math.min(100, this.progress));
      if (this.progress < 0 || this.progress > 100) {
        console.warn(`ProgressBar received out-of-range value: ${this.progress}, clamped to ${clamped}`);
      }
      return clamped;
    }
  }
}
</script>

<style scoped>
.progress-bar-container {
  width: 100%;
  height: 15px;
  background-color: var(--cOther1);
  border-radius: 15px;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  background-color: var(--c1);
  transition: width 0.5s ease;
}
</style>